import { getClientApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    BlockRequest,
    ClientApiGetClientsRequest,
    ClientResponse,
    CreateClientByAdminRequest,
    DeleteRequest,
    GetClientsResponse,
    UnblockRequest,
    UpdateClientRequest,
} from '@/core/generated/api';

/** Предоставляет операции с клиентами */
export const clientService = {
    /** Загружает серверную страницу клиентов */
    async getList(request: ClientApiGetClientsRequest): Promise<GetClientsResponse> {
        try {
            const response = await getClientApi().getClients(request);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает клиента по идентификатору */
    async getById(clientId: string): Promise<ClientResponse> {
        try {
            const response = await getClientApi().getClientById({ clientId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт клиента */
    async create(request: CreateClientByAdminRequest): Promise<ClientResponse> {
        try {
            const response = await getClientApi()
                .createClientByAdmin({
                    createClientByAdminRequest: request,
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет данные клиента */
    async update(clientId: string, request: UpdateClientRequest): Promise<ClientResponse> {
        try {
            const response = await getClientApi()
                .updateClient({
                    clientId,
                    updateClientRequest: request,
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Блокирует профиль клиента по указанной причине */
    async block(clientId: string, request: BlockRequest): Promise<void> {
        try {
            await getClientApi()
                .blockClient({
                    clientId,
                    blockRequest: request
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Разблокирует профиль клиента по указанной причине */
    async unblock(clientId: string, request: UnblockRequest): Promise<void> {
        try {
            await getClientApi()
                .unblockClient({
                    clientId,
                    unblockRequest: request
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Деактивирует профиль клиента */
    async deactivate(clientId: string, request: DeleteRequest): Promise<void> {
        try {
            await getClientApi()
                .deleteClient({
                    clientId,
                    deleteRequest: request
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
